import { Controller } from "stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    var date = Date.parse(this.inputTarget.value);
        
    this.fp = flatpickr(this.inputTarget, {
      mode: 'single',
      minDate: "today"
    });

  }
}
